<template>
  <div class="col-md-12 p-0">
    <div class="card">
      <div class="card-body">
        <h5>Report Service Quality Monitoring</h5>
        <table class="table table-bordered table-hover">
          <thead class="thead-light">
            <tr>
              <th>Contract</th>
              <th>Client</th>
              <th>Submitted At</th>
              <th>Avg Score</th>
              <th>Status</th>
              <th>Action</th>
            </tr>
          </thead>

          <tbody>
            <tr v-for="item in feedbacks" :key="item.contract_id">
              <td>{{ item.contract_number }}</td>
              <td>{{ item.client_name }}</td>
              <td>{{ item.submitted_at || "-" }}</td>
              <td>
                <strong>{{ item.average_score }}</strong>
              </td>
              <td>
                <span class="badge" :class="statusClass(item.status)">
                  {{ item.status }}
                </span>
              </td>
              <td>
                <button
                  class="btn btn-sm btn-primary"
                  @click="viewDetail(item.contract_id)"
                  v-if="item.submitted_at"
                >
                  View
                </button>
              </td>
            </tr>
          </tbody>
        </table>

        <!-- Detail Modal -->
        <div v-if="detail" class="modal-backdrop-custom">
          <div class="modal-content-custom p-4">
            <h5>{{ detail.contract_number }}</h5>
            <p><strong>Client:</strong> {{ detail.client_name }}</p>
            <p><strong>Submitted:</strong> {{ detail.submitted_at }}</p>

            <table class="table table-sm table-bordered">
              <thead>
                <tr>
                  <th>Area ID</th>
                  <th>Clean</th>
                  <th>Detail</th>
                  <th>Tidy</th>
                  <th>Overall</th>
                  <th>Avg</th>
                  <th>Note</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="a in detail.areas" :key="a.area_id">
                  <td>
                    <!-- {{ a.area_id }} -->
                    <strong>Section {{ a.section }}</strong
                    ><br />
                    <small class="text-muted">
                      Lt.{{ a.area_floor }} • {{ a.area_type }} •
                      {{ a.area_name }}
                    </small>
                  </td>

                  <td>{{ renderStar(a.ratings.cleanliness) }}</td>
                  <td>{{ renderStar(a.ratings.detail) }}</td>
                  <td>{{ renderStar(a.ratings.tidiness) }}</td>
                  <td>{{ renderStar(a.ratings.overall) }}</td>

                  <td>
                    <span :class="avgClass(a.average)">
                      {{ a.average }}
                    </span>
                  </td>

                  <td>{{ a.note || "-" }}</td>
                </tr>
              </tbody>
            </table>

            <button class="btn btn-secondary mt-3" @click="detail = null">
              Close
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import axios from "axios";

export default {
  name: "ReportServiceQualityMonitoringIndex",
  data() {
    return {
      feedbacks: [],
      detail: null,
    };
  },
  created() {
    const roleUserPrivilegesName = ["root", "hrd nasional"];

    if (
      !roleUserPrivilegesName.includes(
        localStorage.getItem("userPrivilegesName")
      )
    ) {
      this.isClient =
        localStorage.getItem("userIdPrivileges") == 14 ? true : false;
      this.branchId = localStorage.getItem("userBranchId");
    } else {
      this.isRoot = true;
    }

    this.loadSummary();
  },
  methods: {
    async loadSummary() {
      const res = await axios.get("/report/contract/feedback-summary");
      this.feedbacks = res.data.data;
    },
    async viewDetail(id) {
      const res = await axios.get(`/report/contract/feedback/${id}`);
      this.detail = res.data.data;
    },
    renderStar(value) {
      if (!value) return "-";
      return "⭐ " + value;
    },
    avgClass(avg) {
      if (avg >= 4) return "text-success font-weight-bold";
      if (avg >= 3) return "text-warning font-weight-bold";
      return "text-danger font-weight-bold";
    },
    statusClass(status) {
      if (status === "good") return "badge-success";
      if (status === "warning") return "badge-warning";
      return "badge-danger";
    },
  },
};
</script>
<style>
.modal-backdrop-custom {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
}
.modal-content-custom {
  background: white;
  width: 780px;
  border-radius: 8px;
}
</style>